import dayjs from 'dayjs'

import { Box, Typography, Divider } from '@astro-ui/components'
import { DATE_DM_FORMAT, DATE_WITH_MONTH_NAME_FORMAT } from 'constant/date'

import * as S from '../../DatePickerStyled'

type MenuSelectedType =
  | 'none'
  | 'today'
  | 'yesterday'
  | 'lastWeek'
  | 'lastMonth'
  | 'selectWeekly'
  | 'selectMonthly'
  | 'selectDate'

export type LeftMenuPropsType = {
  title: string
  dateType: 'range' | 'single'
  showDate: boolean
  menuSelected: MenuSelectedType
  dateDefaultValue: {
    today: dayjs.Dayjs
    yesterday: dayjs.Dayjs
    lastWeek: dayjs.Dayjs
    lastMonth: dayjs.Dayjs
  }
  disabledMenu: Exclude<MenuSelectedType, 'none'>[]
  handleSelectMenu: (selected: MenuSelectedType) => void
}

function LeftMenu({
  title,
  dateType,
  showDate,
  dateDefaultValue,
  menuSelected,
  disabledMenu,
  handleSelectMenu,
}: LeftMenuPropsType) {
  return (
    <Box width={!showDate ? '320px' : '215px'}>
      <Typography variant="h5" m="16px">
        {title}
      </Typography>

      <Box display="flex" justifyContent="space-between" mb="12px">
        <Box>
          {dateType === 'single' ? (
            <>
              <S.LeftMenu
                onClick={() => handleSelectMenu('today')}
                selected={menuSelected === 'today'}
                disabled={disabledMenu.includes('today')}
              >
                <Typography variant="body3" color="black">
                  Hari ini
                </Typography>
              </S.LeftMenu>
              <S.LeftMenu
                onClick={() => handleSelectMenu('yesterday')}
                selected={menuSelected === 'yesterday'}
                disabled={disabledMenu.includes('yesterday')}
              >
                <Typography variant="body3" color="black">
                  Kemarin
                </Typography>
              </S.LeftMenu>
            </>
          ) : (
            <>
              <S.LeftMenu
                onClick={() => handleSelectMenu('lastWeek')}
                selected={menuSelected === 'lastWeek'}
                disabled={disabledMenu.includes('lastWeek')}
              >
                <Typography variant="body3" color="black">
                  7 Hari Terakhir
                </Typography>
              </S.LeftMenu>
              <S.LeftMenu
                onClick={() => handleSelectMenu('lastMonth')}
                selected={menuSelected === 'lastMonth'}
                disabled={disabledMenu.includes('lastMonth')}
              >
                <Typography variant="body3" color="black">
                  30 Hari Terakhir
                </Typography>
              </S.LeftMenu>
            </>
          )}
        </Box>
        {!showDate && (
          <Box>
            {dateType === 'single' ? (
              <>
                <S.RightMenu selected={menuSelected === 'today'}>
                  <Typography variant="body3" color="black">
                    {dateDefaultValue.today.format(DATE_WITH_MONTH_NAME_FORMAT)}
                  </Typography>
                </S.RightMenu>
                <S.RightMenu selected={menuSelected === 'yesterday'}>
                  <Typography variant="body3" color="black">
                    {dateDefaultValue.yesterday.format(DATE_WITH_MONTH_NAME_FORMAT)}
                  </Typography>
                </S.RightMenu>
              </>
            ) : (
              <>
                <S.RightMenu selected={menuSelected === 'lastWeek'}>
                  <Typography variant="body3" color="black">
                    {`${dateDefaultValue.lastWeek.format(
                      DATE_DM_FORMAT,
                    )} - ${dateDefaultValue.today.format(DATE_WITH_MONTH_NAME_FORMAT)}`}
                  </Typography>
                </S.RightMenu>
                <S.RightMenu selected={menuSelected === 'lastMonth'}>
                  <Typography variant="body3" color="black">
                    {`${dateDefaultValue.lastMonth.format(
                      DATE_DM_FORMAT,
                    )} - ${dateDefaultValue.today.format(DATE_WITH_MONTH_NAME_FORMAT)}`}
                  </Typography>
                </S.RightMenu>
              </>
            )}
          </Box>
        )}
      </Box>

      <Box p="0 24px">
        <Divider />
      </Box>

      <Box m="12px 0px">
        {dateType === 'range' && (
          <>
            <S.LeftMenu
              onClick={() => handleSelectMenu('selectWeekly')}
              selected={menuSelected === 'selectWeekly'}
              disabled={disabledMenu.includes('selectWeekly')}
            >
              <Typography variant="body3" color="black">
                Per minggu
              </Typography>
            </S.LeftMenu>
            <S.LeftMenu
              onClick={() => handleSelectMenu('selectMonthly')}
              selected={menuSelected === 'selectMonthly'}
              disabled={disabledMenu.includes('selectMonthly')}
            >
              <Typography variant="body3" color="black">
                Per bulan
              </Typography>
            </S.LeftMenu>
          </>
        )}
        <S.LeftMenu
          onClick={() => handleSelectMenu('selectDate')}
          selected={menuSelected === 'selectDate'}
          disabled={disabledMenu.includes('selectDate')}
        >
          <Typography variant="body3" color="black">
            Pilih tanggal
          </Typography>
        </S.LeftMenu>
      </Box>
    </Box>
  )
}

export default LeftMenu
